import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Institutions Logo Config"})
export default class InstitutionsLogoConfig {

    @Input({type: InputType.UNIT, title: "Max Height"})
	public maxHeight?: string;

    @Input({type: InputType.UNIT, title: "Max Width"})
	public maxWidth?: string;

}


// WEBPACK FOOTER //
// ./src/panels/institutions/institutionLogo/InstitutionsLogoConfig.ts